/* 
    @TODO - replace newrelic 'any' with NR typings
    https://forum.newrelic.com/s/hubtopic/aAX8W0000008YeBWAU/typescript-for-browser-agent
*/

declare global {
  interface Window {
    newrelic?: any;
  }
}

export function noticeError(label: string, data = '') {
  if (!window?.newrelic) {
    console.log('missing new relic in window');
    return;
  }

  const error = new Error(`${label} ${data}`);

  window.newrelic.noticeError(error);
}
